/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import NewProject from 'views/BizReply/projects/NewProject';
// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Box, Container, Toolbar, useMediaQuery, Modal } from '@mui/material';

// project imports
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import Header from './Header';
import Sidebar from './Sidebar';
// import Customization from '../Customization';
import navigation from 'menu-items';
import useConfig from 'hooks/useConfig';
import { drawerWidth } from 'features/constant';
import { openDrawer } from 'features/menu/menuSlice';
import { useDispatch, useSelector } from 'react-redux';
import socket from 'socket';
// assets
import { IconChevronRight } from '@tabler/icons';
import useAuth from 'hooks/useAuth';
import { rolePermissionsAPI, teamMemberToTeamAPI } from 'features/team/teamActions';
import {
    // clearingError,
    getTeamProjectsAPI,
    updateMentionFetchStatusChangerOfProject
} from 'features/project/projectActions';
import { getPromptsAPI } from 'features/prompt/promptActions';
import { getAiModelsAPI } from 'features/ai-model/aiModelActions';
import { toast } from 'react-toastify';
import { updateSucceedReport } from 'features/report/reportActions';
// styles
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => {
    return {
        ...theme.typography.mainContent,
        ...(!open && {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.shorter
            }),
            [theme.breakpoints.up('md')]: {
                marginLeft: -(drawerWidth - 65),
                width: `calc(100% - ${drawerWidth}px)`
            },
            [theme.breakpoints.down('md')]: {
                marginLeft: '20px',
                width: `calc(100% - ${drawerWidth}px)`,
                padding: '16px'
            },
            [theme.breakpoints.down('sm')]: {
                marginLeft: '10px',
                width: `calc(100% - ${drawerWidth}px)`,
                padding: '16px',
                marginRight: '10px'
            }
        }),
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.shorter
            }),
            marginLeft: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            width: `calc(100% - ${drawerWidth}px)`,
            [theme.breakpoints.down('md')]: {
                marginLeft: '20px'
            },
            [theme.breakpoints.down('sm')]: {
                marginLeft: '10px'
            }
        })
    };
});

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    const {
        project: { showProjectCreateModal, project },
        team: { selectedTeam, rolePermissions, loading: teamLoading, teams, myPermissions },
        subscription: { selfSubscription },
        prompt: { loading }
    } = useSelector((state) => state);
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('lg'));
    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);
    const { container } = useConfig();

    React.useEffect(() => {
        dispatch(openDrawer(!matchDownMd));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownMd]);
    const { dbUser, user } = useAuth();

    React.useEffect(() => {
        if (teamLoading || !teams?.length) {
            return;
        }
        if (selectedTeam?._id) {
            getTeamProjectsAPI({ teamId: selectedTeam?._id || '' })();
            if (!loading) {
                getPromptsAPI()();
                getAiModelsAPI()();
            }
        }

        if (!rolePermissions?.length) {
            rolePermissionsAPI();
        }
        console.log(myPermissions?.length, 'rolePermissions?.length');
    }, [selectedTeam?._id, teamLoading, myPermissions?.length]);
    const userId = dbUser?._id || user?.id;
    React.useEffect(() => {
        socket.connect();
        if (project?._id) {
            const projectMentionStatus = `mentionsStatus:${project?._id}`;
            console.log(`Socket is connected mentionsStatus`, projectMentionStatus);
            socket.on(projectMentionStatus, ({ message: { mentionsStatus }, purposeName }) => {
                // "succeed"
                updateMentionFetchStatusChangerOfProject({ _id: project._id, mentionsStatus, purposeName })();
                console.log({ mentionsStatus, purposeName });
            });
        }
    }, [project?._id]);
    React.useEffect(() => {
        // socket.connect();
        if (userId) {
            const reportStatus = `report:${userId}`;
            // console.log(`Socket is connected pdf status---------------------`, reportStatus);
            socket.on(
                reportStatus,
                ({
                    message: {
                        userId,
                        reportId,
                        item: { pdfUrl, pageCount }
                    }
                }) => {
                    console.log('==========Alhamdu lillah get report with socket');
                    updateSucceedReport({ _id: reportId, userId, pageCount, pdfUrl })();
                }
            );

            const invitationConfirmationStatus = `invitationConfirmationStatus:${userId}`;
            socket.on(invitationConfirmationStatus, ({ message: { status, success } }) => {
                if (status === 200 && success) {
                    teamMemberToTeamAPI({ selectCollaborationTeam: true });
                    toast.success(`Invitation has been accepted!`);
                }
            });
        }
    }, [userId]);
    const isTrial = selfSubscription?.type && selfSubscription?.type === 'trial';
    const header = useMemo(
        () => (
            <Toolbar sx={{ flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between' }}>
                <Header {...{ isTrial, expire: selfSubscription?.expire }} />
                <Modal
                    open={showProjectCreateModal}
                    sx={{ '.MuiBox-root:nth-child(3)': { minWidth: { md: '600px', sx: 'unset', sm: '500px' } } }}
                >
                    <NewProject />
                </Modal>
            </Toolbar>
        ),
        [showProjectCreateModal]
    );

    return (
        <Box sx={{ display: 'flex' }}>
            <AppBar
                enableColorOnDark
                position="fixed"
                color="inherit"
                elevation={0}
                sx={{
                    bgcolor: theme.palette.background.default,
                    transition: drawerOpen ? theme.transitions.create('width') : 'none',
                    width: { sm: '100%', md: 'calc(100% - 260px)' },
                    height: { xs: isTrial ? '120px' : '70px', sm: '70px' }
                }}
            >
                {header}
            </AppBar>

            <Sidebar />

            <Main
                open={drawerOpen}
                // sx={{ mt: { xs: '120px', sm: '70px' } }}
                sx={{ mt: '70px' }}
            >
                {container && (
                    <Container maxWidth="lg">
                        <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
                        <Outlet />
                    </Container>
                )}
                {!container && (
                    <>
                        <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
                        <Outlet />
                    </>
                )}
            </Main>
        </Box>
    );
};

export default MainLayout;
